import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../repositories/common/json_query';

export function trackNewbuildingEntryBannerClick(bannerId: string, jsonQuery: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'new_building_banner_click',
    label: bannerId,
    sc: jsonQuery,
    useLastProducts: true,
  });
}

export function trackNewbuildingEntryBannerShow(bannerId: string, jsonQuery: IJsonQuery) {
  ca('eventSite', {
    name: 'soprevent',
    category: 'Listing',
    action: 'new_building_banner_show_sopr',
    label: bannerId,
    sc: jsonQuery,
    useLastProducts: true,
  });
}
